// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3wK9y","alertIcon":"ConfirmModal_alertIcon__3aW_M"};